import styled from 'styled-components';
import { StyledEmbeddedWidgetCon, StyledProductItemCon } from '../../../skins';

export const StyledLineEmbeddedWidgetCon = styled(StyledEmbeddedWidgetCon)``;

export const StyledLineProductItemCon = styled(StyledProductItemCon)`
  & .mr-product-item__actions--vertical-full-width {
    max-width: fit-content;
    align-items: flex-end;
  }
`;
